import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import { BsBasket3 } from 'react-icons/bs';
import { getTopOffset, getLeftOffset } from '../../helpers';

const FlyOutBasketIcon = ({ handleOnClick, basketTotal }) => {
  const ref = useRef(null);

  const onClick = e => {
    if (typeof window === 'undefined' || !ref.current) return;
    const { left, top } = ref.current.getBoundingClientRect();
    const offsetTopToUse = getTopOffset(top);
    const offsetLeftToUse = getLeftOffset(left);
    handleOnClick(offsetTopToUse, offsetLeftToUse);
  };

  const iconVariantClassname = `blaze-ecommerce-flyout-basket__icon-variant`;

  return (
    <div
      ref={ref}
      id="flyout-basket-icon-variant"
      role="button"
      className={iconVariantClassname}
      onClick={onClick}>
      <span className={`${iconVariantClassname}__total`}>{basketTotal}</span>
      <BsBasket3 />
    </div>
  );
};

FlyOutBasketIcon.propTypes = {
  handleOnClick: PropTypes.func.isRequired,
  basketTotal: PropTypes.string
};

FlyOutBasketIcon.defaultProps = {
  basketTotal: '0'
};

export default FlyOutBasketIcon;
